import styled from "styled-components";
import { mobile_normal, mobile_title } from "../../const/fonts";
import { BG_GAMES, BOX_SHADOW, DARKER, PRIMARY, SECONDARY } from "../../const/colors";

export const ContainerModal = styled.div`
  background-color: #fff;
  border: 1px solid ${PRIMARY};
  text-align: center;
  padding: 20px; // Añadir padding para mayor espacio interior
  width: 100%; // Ocupa todo el ancho disponible
  max-width: 600px; // Limita el ancho máximo para pantallas grandes
  height: auto; // Ajusta automáticamente la altura en función del contenido
  margin: auto; // Centra el modal horizontalmente
  border-radius: 8px; // Añadir un borde redondeado opcional
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); // Añadir sombra opcional para un mejor diseño
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;

  label {
    color: #000000;
    font-weight: bold;
    font-size: 0.8rem;
    padding: 0.5rem;
    margin-top: 0.5rem;

    > span {
      color: red;
      margin-left: 0.5rem;
    }
  }

  select, input {
    background-color: transparent;
    border: 1px solid ${PRIMARY};
    padding: 0.5rem;
    color: #888;
    outline: none;
    transition: all 0.3s ease;
    cursor: pointer;
  }

  input {
    color: #000000;
    ::placeholder {
      color: #888;
    }
  }

  select:hover, input:hover {
    border-color: #000;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
    filter: invert(1);
  }

  @media screen and (max-width: 768px) {
    text-align: center;
    label, input, select {
      font-size: ${mobile_normal};
    }
    input::placeholder, select::placeholder {
      text-align: center;
    }
  }
`;

export const ButtonsContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-height: 700px) {
    margin-top: 1rem;
  }

  @media screen and (max-width: 480px) {
    justify-content: space-evenly;
  }
`;

export const Button = styled.button.attrs((props) => ({
  className: props.className,
}))`
  width: 40%;
  font-size: 0.9rem;
  font-weight: bold;
  border: ${props=> props.primary ? '1px solid transparent' : `1px solid ${PRIMARY}`};
  background-color: ${props=> props.primary ? PRIMARY : 'transparent'};
  color: ${props => props.primary ? SECONDARY : PRIMARY} ;
  box-shadow: ${props => props.primary ? BOX_SHADOW : 'none'};
  padding: 0.7rem;
  margin-top: 1.5rem;
  margin-left: ${props => props.primary ? '1rem' : 0};
  transition: all .3s ease-in-out;
  
  &:hover:not(:disabled){
    cursor: pointer;
    background-color: #fff;
    color: ${SECONDARY};
  }

  &:disabled {
    opacity: 0.8;
    box-shadow: none;
  }

  &.active {
    background-color: #fff;
    color: ${SECONDARY};
  }

  &.tupay {
    width: 48%;
  }

  @media screen and (max-width: 480px) {
    width: 50%;
    margin-top: 1rem;
  }

  @media screen and (max-height: 690px) {
    margin-top: 0.5rem;
    padding: 0.5rem;
  }
`;